import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private isDev = false; // Default to prod environment
  private environmentSubject = new BehaviorSubject<boolean>(this.isDev);

  // URLs for different environments
  private devEnvironment = {
    apiBaseUrl: 'https://dev.api.parking.ldcs.ae',
    myFatoorahBaseUrl: 'https://dev.api.parking.ldcs.ae/my-fatoorah',
    stripeBaseUrl: 'https://dev.api.parking.ldcs.ae/stripe',
    niBaseUrl: 'https://dev.api.parking.ldcs.ae/ni',
    knetBaseUrl: 'https://dev.api.parking.ldcs.ae/knet'
  };

  private prodEnvironment = {
    apiBaseUrl: 'https://api.parking.ldcs.ae',
    myFatoorahBaseUrl: 'https://api.parking.ldcs.ae/my-fatoorah',
    stripeBaseUrl: 'https://api.parking.ldcs.ae/stripe',
    niBaseUrl: 'https://api.parking.ldcs.ae/ni',
    knetBaseUrl: 'https://api.parking.ldcs.ae/knet'
  };

  constructor() {
    // Check if there's a saved environment setting in localStorage
    const savedEnv = localStorage.getItem('useDevEnvironment');
    if (savedEnv !== null) {
      this.isDev = savedEnv === 'true';
      this.environmentSubject.next(this.isDev);
    }
  }

  // Toggle between dev and prod environments
  toggleEnvironment(): void {
    this.isDev = !this.isDev;
    localStorage.setItem('useDevEnvironment', String(this.isDev));
    this.environmentSubject.next(this.isDev);
  }

  // Get the current environment status
  getEnvironmentStatus() {
    return this.environmentSubject.asObservable();
  }

  // Is currently using dev environment
  isDevEnvironment(): boolean {
    return this.isDev;
  }

  // Get appropriate URLs based on the current environment
  getApiBaseUrl(): string {
    return this.isDev ? this.devEnvironment.apiBaseUrl : this.prodEnvironment.apiBaseUrl;
  }

  getMyFatoorahBaseUrl(): string {
    return this.isDev ? this.devEnvironment.myFatoorahBaseUrl : this.prodEnvironment.myFatoorahBaseUrl;
  }

  getStripeBaseUrl(): string {
    return this.isDev ? this.devEnvironment.stripeBaseUrl : this.prodEnvironment.stripeBaseUrl;
  }

  getNiBaseUrl(): string {
    return this.isDev ? this.devEnvironment.niBaseUrl : this.prodEnvironment.niBaseUrl;
  }

  getKnetBaseUrl(): string {
    return this.isDev ? this.devEnvironment.knetBaseUrl : this.prodEnvironment.knetBaseUrl;
  }
} 